// Toast Notification System
// Theme-styled notifications for user feedback

(function() {
  'use strict';

  let toastContainer = null;

  // Icons for each toast type
  const icons = {
    success: '✓',
    error: '✕',
    warning: '⚠',
    info: 'ℹ'
  };

  // Initialize toast container
  function initContainer() {
    if (!toastContainer) {
      toastContainer = document.createElement('div');
      toastContainer.className = 'toast-container';
      toastContainer.setAttribute('aria-live', 'polite');
      toastContainer.setAttribute('aria-atomic', 'true');
      document.body.appendChild(toastContainer);
    }
  }

  // Show toast notification
  function showToast(message, type = 'info', duration = 4000) {
    initContainer();

    const toast = document.createElement('div');
    toast.className = `toast toast--${type}`;
    toast.setAttribute('role', 'status');

    const icon = document.createElement('span');
    icon.className = 'toast__icon';
    icon.textContent = icons[type] || icons.info;

    const messageEl = document.createElement('span');
    messageEl.className = 'toast__message';
    messageEl.textContent = message;

    const closeBtn = document.createElement('button');
    closeBtn.className = 'toast__close';
    closeBtn.setAttribute('type', 'button');
    closeBtn.setAttribute('aria-label', 'Close notification');
    closeBtn.textContent = '×';

    toast.appendChild(icon);
    toast.appendChild(messageEl);
    toast.appendChild(closeBtn);

    toastContainer.appendChild(toast);

    // Close button handler
    closeBtn.addEventListener('click', function() {
      dismissToast(toast);
    });

    // Auto dismiss after duration
    if (duration > 0) {
      setTimeout(function() {
        dismissToast(toast);
      }, duration);
    }

    return toast;
  }

  // Dismiss toast with animation
  function dismissToast(toast) {
    if (!toast || toast.classList.contains('toast--hiding')) return;

    toast.classList.add('toast--hiding');

    setTimeout(function() {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }

      // Remove container if empty
      if (toastContainer && toastContainer.children.length === 0) {
        toastContainer.remove();
        toastContainer = null;
      }
    }, 300);
  }

  // Expose to global scope
  window.showToast = showToast;

  // Convenience methods
  window.toast = {
    success: function(message, duration) {
      return showToast(message, 'success', duration);
    },
    error: function(message, duration) {
      return showToast(message, 'error', duration);
    },
    warning: function(message, duration) {
      return showToast(message, 'warning', duration);
    },
    info: function(message, duration) {
      return showToast(message, 'info', duration);
    }
  };
})();
